// @flow
import { StyledLabel } from '@src/common-utils/styledComponents';
import { Label } from 'semantic-ui-react';
import { Spacer } from '@presentational/spacing/Spacer';
import { StyledExternalLink } from '@presentational/ExternalLink';
import React from 'react';

export const VBDLegendContainer = () => (
  <StyledLabel>
    <Label
      color="teal"
      ribbon={true}
      style={{
        marginLeft: '-15px',
      }}
    >
      SG
    </Label>
    SG (System Generated) discounts are automatically generated based on configured usage. In case
    of a conflict with user-defined discounts, the user-defined discount will always take
    precedence.
    <Spacer x={5} />
    <StyledExternalLink
      href="https://confluentinc.atlassian.net/wiki/spaces/PM/pages/4595974457/System+Generated+Discounting"
      text="Read More"
    />
  </StyledLabel>
);
